import { useTranslation } from 'react-i18next';
import { uniqueId } from 'lodash';
import React from 'react';
import { Input } from 'shared/components';
import SearchIcon from 'assets/svgs/searchIcon.svg';
import FiltersIcon from 'assets/svgs/filterIconBlue.svg';

const SearchBox = (props) => {
  const { t } = useTranslation();
  return (
    <div
      className={`search-box ${props.className} ${
        props.searchAvailable ? 'input-displayed' : 'btn-displayed'
      }`}>
      {
        <div className="input-search-container">
          {!props.showFilters && (
            <>
              <div className="filter-button show-desktop" onClick={() => props.toggleFilters(true)}>
                <FiltersIcon /> {t('rosters.showFilters')}
              </div>
              <div className="vertical-separator"></div>
            </>
          )}
          <span className="search-label">{t('roomRoster.searchBy')}</span>
          <Input
            autocomplete="false"
            type="text"
            name="searchInput"
            id={uniqueId('search-input')}
            value={props.searchValue}
            placeholder="Name"
            onChange={props.onChange}
            onKeyPress={props.onKeyPress}
            errors={props.errors}
            clearValue={props.clearSearch}
          />
          <button className="btn-search" onClick={props.onSearch}>
            <SearchIcon />
          </button>
        </div>
      }
    </div>
  );
};

export default SearchBox;
